import { Component, Input, OnInit } from '@angular/core';

import { Property, PropertySet } from '@mirage-projects/cw-models';
import { DbPcvizService } from '@mirage-projects/cw-pcviz-core';

import { PropertyBagService } from '../property-bag.service';

/**
 * This component is responsible to show the classification property.
 */
@Component({
    selector: 'cw-property-classification',
    templateUrl: './property-classification.component.html',
    styleUrls: ['./property-classification.component.scss'],
    standalone: false,
})
export class PropertyClassificationComponent implements OnInit {
    /** This object comes from the core and provides methods to obtain and set the value of the properties */
    @Input() propertySet!: PropertySet;

    /** Input field with the required information for this field type */
    @Input() property!: Property;

    value = false;
    color!: number[];

    constructor(
        private propertyBagService: PropertyBagService,
        private dbPcvizService: DbPcvizService
    ) {}

    ngOnInit(): void {
        this.value = this.propertyBagService.getValueProperty(this.propertySet, this.property, 'active');
        const colorHex = this.propertyBagService.getValueProperty(this.propertySet, this.property, 'color');
        if (!colorHex) {
            this.color = [0, 0, 0];
            return;
        }

        const colorRGB = this.dbPcvizService.getUtils().hexToRgb(colorHex);
        this.color = [colorRGB.r, colorRGB.g, colorRGB.b];
    }

    onChange(checked: boolean): void {
        this.property.value = { active: checked };
        this.propertyBagService.setValueProperty(this.propertySet, this.property);
    }
}
